import apiClient from 'utilities/apiClient';

export const resetpassword = (payload) => {
  return apiClient.post(`${apiClient.Urls.resetPassword}`, payload);
};
